import { Loading } from '@/components/Loading'
import Step2Wrapper from '@/containers/steps/travel/Step2/Step2Wrapper'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { OffersTravelProvider } from '@/context/OffersTravelProvider'
import { QuotesProvider } from '@/context/QuotesContext'
import { SidebarProvider } from '@/context/SidebarContext'
import { StepsProvider } from '@/context/StepsContext'
import { WizzardHeaderProvider } from '@/context/WizzardHeaderContext'
import { WithAuth } from '@/hoc/WithAuth'

const Step2PageComponent = () => {
  const { insuranceParams, isLoadingData } = useInsuranceParams()

  return (
    <StepsProvider currentStepId={2}>
      <SidebarProvider>
        <WizzardHeaderProvider>
          <QuotesProvider>
            {(isLoadingData) && <Loading large={true} />}
            {insuranceParams &&
              <OffersTravelProvider>
                <Step2Wrapper />
              </OffersTravelProvider>
            }
          </QuotesProvider>
        </WizzardHeaderProvider>
      </SidebarProvider>
    </StepsProvider>
  )
}

export const Step2Page = WithAuth(Step2PageComponent)